










import Vue from 'vue'

import MailIcon from '@/assets/svg/emails/mail.svg?inline'
import GmailIcon from '@/assets/svg/emails/gmail.svg?inline'
import YahooIcon from '@/assets/svg/emails/yahoo.svg?inline'
import YandexIcon from '@/assets/svg/emails/yandex.svg?inline'
import OutlookIcon from '@/assets/svg/emails/outlook.svg?inline'

interface Computed {
  provider: string
  buttonIcon: string
  buttonLink: string
}

interface Props {
  email: string
}

export default Vue.extend<{}, {}, Computed, Props>({
  components: {
    MailIcon,
    GmailIcon,
    YahooIcon,
    YandexIcon,
    OutlookIcon,
  },
  props: {
    email: {
      default: () => '',
    },
  },
  computed: {
    provider(): string {
      return (this.email || '').split('@')[1]
    },
    buttonIcon(): string {
      switch (this.provider) {
        case 'mail.ru':
          return 'MailIcon'
        case 'gmail.com':
          return 'GmailIcon'
        case 'yahoo.com':
          return 'YahooIcon'
        case 'yandex.ru':
          return 'YandexIcon'
        case 'outlook.com':
          return 'OutlookIcon'
        default:
          return ''
      }
    },
    buttonLink(): string {
      switch (this.provider) {
        case 'mail.ru':
          return 'https://account.mail.ru'
        case 'gmail.com':
          return 'https://mail.google.com'
        case 'yahoo.com':
          return 'https://mail.yahoo.com'
        case 'yandex.ru':
          return 'https://passport.yandex.ru'
        case 'outlook.com':
          return 'https://outlook.office.com'
        default:
          return ''
      }
    },
  },
})
